module.exports = __webpack_public_path__ + "img/boomerang.5e10eb52.svg";